(function () {
  var BREAKPOINT = 1024;
  var lastIsMobile = window.innerWidth <= BREAKPOINT;

  function lightboxEl() {
    return document.getElementById('instafeed-lightbox') || document.querySelector('.instafeed-lightbox');
  }

  function isOpen(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function unlockPage() {
    document.body.classList.remove('instafeed-body-no-scroll');
    document.documentElement.classList.remove('instafeed-body-no-scroll');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow-y');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow-y');
  }

  function restoreCloseButton(el) {
    var closeBtn = el.querySelector('.instafeed-close-button');
    var bar = el.querySelector('.instafeed-bottom-bar');
    if (!closeBtn || !bar || bar.contains(closeBtn)) return;
    if (bar.firstChild) bar.insertBefore(closeBtn, bar.firstChild);
    else bar.appendChild(closeBtn);
  }

  function forceClose(el) {
    if (!el) {
      unlockPage();
      return;
    }
    restoreCloseButton(el);
    var closeBtn = el.querySelector('.instafeed-close-button');
    if (closeBtn) {
      try {
        closeBtn.click();
      } catch (e) {}
    }
    el.style.setProperty('display', 'none', 'important');
    el.style.opacity = '0';
    unlockPage();
  }

  function onBreakpointChange() {
    var el = lightboxEl();
    if (!el || !isOpen(el)) {
      unlockPage();
      return;
    }
    restoreCloseButton(el);
    forceClose(el);
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    var isMobile = window.innerWidth <= BREAKPOINT;
    if (isMobile === lastIsMobile) return;
    lastIsMobile = isMobile;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onBreakpointChange, 50);
  });
})();

(function () {
  function activeModal() {
    return document.querySelector(
      '.yotpo-lightbox.yotpo-lightbox-new .yotpo-modal.yotpo-modal-active'
    );
  }

  function pinCloseToCard(modal) {
    var container = modal.querySelector('.yotpo-lightbox-container');
    var closeBtn = modal.querySelector('.yotpo-close-modal');
    if (!container || !closeBtn) return;
    if (!container.contains(closeBtn)) {
      container.appendChild(closeBtn);
    }

    closeBtn.style.setProperty('display', 'block', 'important');
    closeBtn.style.setProperty('visibility', 'visible', 'important');
    closeBtn.style.setProperty('opacity', '1', 'important');
    closeBtn.style.setProperty('position', 'absolute', 'important');
    closeBtn.style.setProperty('top', '-12px', 'important');
    closeBtn.style.setProperty('right', '-12px', 'important');
    closeBtn.style.setProperty('left', 'auto', 'important');
    closeBtn.style.setProperty('bottom', 'auto', 'important');
    closeBtn.style.setProperty('width', '36px', 'important');
    closeBtn.style.setProperty('height', '36px', 'important');
    closeBtn.style.setProperty('z-index', '10050', 'important');
    closeBtn.style.setProperty('margin', '0', 'important');
    closeBtn.style.setProperty('padding', '0', 'important');
    closeBtn.style.setProperty('border-radius', '50%', 'important');
    closeBtn.style.setProperty('background', '#f3f3f3', 'important');
    closeBtn.style.setProperty('background-image', 'none', 'important');
    closeBtn.style.setProperty('box-shadow', '0 1px 4px rgba(33, 30, 31, 0.22)', 'important');
    closeBtn.style.setProperty('pointer-events', 'auto', 'important');

    var icon = closeBtn.querySelector('.yotpo-icon-cross');
    if (icon) {
      icon.style.setProperty('display', 'block', 'important');
      icon.style.setProperty('visibility', 'visible', 'important');
      icon.style.setProperty('opacity', '1', 'important');
      icon.style.setProperty('position', 'absolute', 'important');
      icon.style.setProperty('top', '0', 'important');
      icon.style.setProperty('right', '0', 'important');
      icon.style.setProperty('left', '0', 'important');
      icon.style.setProperty('bottom', '0', 'important');
      icon.style.setProperty('width', '36px', 'important');
      icon.style.setProperty('height', '36px', 'important');
      icon.style.setProperty('font-size', '0', 'important');
      icon.style.setProperty('color', 'transparent', 'important');
      icon.style.setProperty(
        'background-image',
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23211e1f' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'/%3E%3Cline x1='6' y1='6' x2='18' y2='18'/%3E%3C/svg%3E\")",
        'important'
      );
      icon.style.setProperty('background-repeat', 'no-repeat', 'important');
      icon.style.setProperty('background-position', 'center', 'important');
      icon.style.setProperty('background-size', '18px 18px', 'important');
      icon.style.setProperty('background-color', 'transparent', 'important');
    }
  }

  function stackReviewUnderImage(modal) {
    if (window.innerWidth > 1024) return;
    var content = modal.querySelector('.yotpo-lightbox-content-container');
    if (!content) return;
    content.style.setProperty('display', 'block', 'important');
    content.style.setProperty('visibility', 'visible', 'important');
    content.style.setProperty('opacity', '1', 'important');
    content.style.setProperty('position', 'static', 'important');
    content.style.setProperty('width', '100%', 'important');
    content.style.setProperty('height', 'auto', 'important');
    content.style.setProperty('max-height', 'none', 'important');
    content.style.setProperty('right', 'auto', 'important');
    content.style.setProperty('top', 'auto', 'important');
  }

  function fixAvatarCircles(modal) {
    var avatars = modal.querySelectorAll('.yotpo-icon-profile');
    for (var i = 0; i < avatars.length; i++) {
      var el = avatars[i];
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('justify-content', 'center', 'important');
      el.style.setProperty('flex', '0 0 36px', 'important');
      el.style.setProperty('flex-grow', '0', 'important');
      el.style.setProperty('width', '36px', 'important');
      el.style.setProperty('height', '36px', 'important');
      el.style.setProperty('min-width', '36px', 'important');
      el.style.setProperty('max-width', '36px', 'important');
      el.style.setProperty('min-height', '36px', 'important');
      el.style.setProperty('max-height', '36px', 'important');
      el.style.setProperty('aspect-ratio', '1 / 1', 'important');
      el.style.setProperty('padding', '0', 'important');
      el.style.setProperty('margin', '0 10px 0 0', 'important');
      el.style.setProperty('border-radius', '50%', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
      el.style.setProperty('float', 'none', 'important');

      var letter = el.querySelector('.yotpo-user-letter');
      if (letter) {
        letter.style.setProperty('position', 'absolute', 'important');
        letter.style.setProperty('inset', '0', 'important');
        letter.style.setProperty('width', 'auto', 'important');
        letter.style.setProperty('min-width', '0', 'important');
        letter.style.setProperty('height', 'auto', 'important');
        letter.style.setProperty('display', 'flex', 'important');
        letter.style.setProperty('align-items', 'center', 'important');
        letter.style.setProperty('justify-content', 'center', 'important');
        letter.style.setProperty('line-height', '1', 'important');
      }
    }
  }

  function polish() {
    var modal = activeModal();
    if (!modal) return;
    pinCloseToCard(modal);
    stackReviewUnderImage(modal);
    fixAvatarCircles(modal);
  }

  function schedulePolish() {
    setTimeout(polish, 50);
    setTimeout(polish, 250);
  }

  document.addEventListener('click', schedulePolish, true);
})();
